import { render, staticRenderFns } from "./PictionaryPage.vue?vue&type=template&id=f9da87a4&scoped=true&"
import script from "./PictionaryPage.vue?vue&type=script&lang=js&"
export * from "./PictionaryPage.vue?vue&type=script&lang=js&"
import style0 from "./PictionaryPage.vue?vue&type=style&index=0&id=f9da87a4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9da87a4",
  null
  
)

export default component.exports